import { Facebook, Instagram, Youtube, Linkedin } from "lucide-react";

const footerLinks = [
  { label: "Home", href: "#home", id: "footer-home" },
  { label: "What We Handle", href: "#services", id: "footer-services" },
  { label: "Who It's For", href: "#who", id: "footer-who" },
  { label: "Get Started", href: "#get-started", id: "footer-get-started" },
  { label: "Privacy Policy", href: "#", id: "footer-privacy" },
  { label: "Terms", href: "#", id: "footer-terms" },
];

const socials = [
  { icon: Facebook, label: "Facebook", id: "social-facebook" },
  { icon: Instagram, label: "Instagram", id: "social-instagram" },
  { icon: Youtube, label: "YouTube", id: "social-youtube" },
  { icon: Linkedin, label: "LinkedIn", id: "social-linkedin" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-neutral-800 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-12">
          <div>
            <img src="/logo.png" alt="I Stay Trucking" className="h-12 w-auto" data-testid="footer-logo" />
            <p className="mt-6 font-display text-lg font-semibold uppercase tracking-wide text-neutral-300" data-testid="footer-tagline">
              Own The Company. <span className="text-orange-500">We'll Run It.</span>
            </p>
            <div className="mt-8 flex gap-3" data-testid="footer-socials">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  data-testid={s.id}
                  className="flex h-11 w-11 items-center justify-center border border-neutral-800 text-neutral-400 transition-colors duration-200 hover:border-orange-500 hover:text-orange-500"
                >
                  <s.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <nav className="grid grid-cols-2 gap-x-16 gap-y-4" data-testid="footer-nav">
            {footerLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={l.id}
                className="text-sm font-semibold uppercase tracking-wider text-neutral-400 transition-colors duration-200 hover:text-orange-500"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-14 border-t border-neutral-800 pt-8">
          <p className="text-xs text-neutral-600" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} I Stay Trucking. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
